import { Ng2StateDeclaration } from '@uirouter/angular';
import { Ng2RootComponent } from './ng2Root.component';
import {
  airlinesCompatibilityProvider,
  currentAirlineCompatibilityProvider,
  currentLanguageCompatibilityProvider,
  currentLanguageProvider,
  currentTenantProvider,
  currentUserCompatibilityProvider,
  currentUserProvider,
  languagesCompatibilityProvider,
  languagesProvider,
  menuOptionsCompatibilityProvider,
  menuOptionsProvider,
  sessionTimeoutCompatibilityProvider,
  sessionTimeoutProvider,
  tenantsProvider
} from './app.root.resolvers';

export const ng2RootState: Ng2StateDeclaration = {
  name: "ng2Root",
  abstract: true,
  url: "",
  component: Ng2RootComponent,
  params: {
    menuOptions: {
      dynamic: true,
      value: false
    }
  },
  resolve: [
    tenantsProvider,
    airlinesCompatibilityProvider,
    currentTenantProvider,
    currentAirlineCompatibilityProvider,
    currentLanguageProvider,
    currentLanguageCompatibilityProvider,
    currentUserProvider,
    currentUserCompatibilityProvider,
    languagesProvider,
    languagesCompatibilityProvider,
    sessionTimeoutProvider,
    sessionTimeoutCompatibilityProvider,
    menuOptionsProvider,
    menuOptionsCompatibilityProvider
  ]
};
